import { faCloudDownloadAlt, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, styled, Typography } from '@mui/material'
import { ChangeEvent, useId, useState } from 'react'
import { Anexo } from '../../interfaces/entities/Reembolso/Anexo'
import { AnexoButtonProps } from '../../interfaces/props/Financeiro/Reembolso/AnexoButtonProps'
import { useAccessibility } from '../../Store/contexts/AccessibilityContext'
import DefaultButton from '../Accessibility/DefaultButton'
import ModalAction from '../ModalAction'
import ModalFeedBack from '../ModalFeedBack'
import './styles.css'
import { sxButtonLabel, sxButtonText, sxButtonTextAccessibility } from './sxProps'

const AnexoButton = (props: AnexoButtonProps) => {

  const accessibility = useAccessibility();

  const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
  });

  const buttonId = useId();

  const [modalAction, setModalAction] = useState<null | {
    handleShowModal?: () => void; textOutlinedButton: string; textContainedButton: string;
    title: string; subTitle?: string; handleOutlinedButton?: () => void; handleContainedButton?: () => void; icon: "error" | "success" | "warning"
  }>(null);
  const [modalFeedback, setModalFeedback] = useState<null | {
    icon?: 'error' | 'success' | 'warning', title?: string, textButton?: string, subTitle?: string,
    closeAction: () => void, showButtonModal: boolean, buttonAction?: () => void
  }>(null);

  const openModalDeleteAnexo = (anexo: Anexo, index: number) => {
    setModalAction({
      title: 'Excluir anexo',
      subTitle: `Tem certeza que deseja excluir o anexo ${anexo.nomeArquivo}?`,
      textOutlinedButton: 'Cancelar',
      textContainedButton: 'Excluir anexo',
      handleContainedButton: () => removeAnexo(index),
      handleOutlinedButton: handleCloseModalAction,
      handleShowModal: handleCloseModalAction,
      icon: 'warning'
    })
  }

  const openModalFeedback = (
    icon: 'error' | 'success' | 'warning', title: string, subtitle: string, textButton: string, closeAction: () => void, buttonAction: () => void
  ) => {
    setModalFeedback({
      icon: icon,
      title: title,
      subTitle: subtitle,
      textButton: textButton,
      showButtonModal: true,
      closeAction: closeAction,
      buttonAction: buttonAction
    });
  }

  const closeModalFeedback = () => {
    setModalFeedback(null);

    setTimeout(() => {
      const buttonElem = document.getElementById(buttonId);
      if (buttonElem) {
        buttonElem.focus();
      }
    }, 0);
  }

  const handleCloseModalAction = () => {
    setModalAction(null);
  }

  const handleFileInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (!files) return;

    const anexos: Array<Anexo> = [];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (file.size > 4 * 1024 * 1024) {
        openModalFeedback('warning', '', 'O arquivo selecionado é muito grande. Por favor, selecione um arquivo menor que 4MB.', 'Fechar', closeModalFeedback, closeModalFeedback);
        return;
      }

      if (!(/\.(pdf|jpg|png|doc|docx)$/i).test(file.name)) {
        openModalFeedback(
          'warning',
          '',
          'Somente são aceitos arquivos nos formatos .pdf, .jpg, .png, .doc ou .docx.',
          'Fechar',
          closeModalFeedback,
          closeModalFeedback
        );
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result as string;
        const [prefix, base64Data] = base64String.split(',');
        anexos.push({
          nomeArquivo: file.name,
          arquivo: base64Data,
          tipoArquivo: prefix
        });

        if (anexos.length === files.length) {
          var _anexos = props.anexos.concat(anexos);
          props.salvarAnexos(_anexos);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const removeAnexo = (posicao: number) => {
    var _anexo = [];
    if (posicao >= 0 && posicao < props.anexos.length) {
      _anexo = props.anexos.slice(0, posicao).concat(props.anexos.slice(posicao + 1));
    } else {
      console.log("Posição inválida");
      _anexo = props.anexos;
    }
    props.salvarAnexos(_anexo);
    handleCloseModalAction();
  };

  return (
    <>
      <div className='container-anexo-button'>
        <DefaultButton
          variant='outlined'
          id={buttonId}
          startIcon={<FontAwesomeIcon icon={faCloudDownloadAlt} style={accessibility.buttonTextStyleAccessibility} />}
          role={undefined}
          component="label"
          onKeyDown={(e) => { if (e.key === 'Enter') { e?.currentTarget.click(); }}}
        >
          <b style={accessibility.buttonTextStyleAccessibility} aria-hidden="true">ANEXAR ARQUIVOS</b>
          <VisuallyHiddenInput
            type="file"
            accept=".pdf,.doc,.docx,.png,.jpg"
            onChange={handleFileInputChange}
            multiple
            tabIndex={-1}
            aria-label="Anexar arquivos"
          />
        </DefaultButton>
        {props.anexos.length > 0 && <div className='anexos-list-container'>
          {props.anexos.map((anexo, index) =>
            <Button
              onClick={() => openModalDeleteAnexo(anexo, index)}
              variant='text'
              sx={accessibility.contrastMode ? sxButtonTextAccessibility : sxButtonText}
              key={index}
              endIcon={<FontAwesomeIcon icon={faTimes} />}
              aria-label={`Remover arquivo ${anexo.nomeArquivo}`}
            >
              <Typography
                sx={sxButtonLabel}
              >
                {anexo.nomeArquivo}
              </Typography>
            </Button>
          )}
        </div>}
      </div>
      <ModalFeedBack
        showModal={!!modalFeedback}
        handleShowModal={modalFeedback?.closeAction}
        title={modalFeedback?.title as string}
        subTitle={modalFeedback?.subTitle as string}
        icon={modalFeedback?.icon as 'success' | 'error' | 'warning'}
        showButtonModal={modalFeedback?.showButtonModal}
        textButton={modalFeedback?.textButton as string}
        handleButtonModal={modalFeedback?.buttonAction}
      />
      <ModalAction
        showModal={!!modalAction}
        handleShowModal={modalAction?.handleShowModal}
        icon={modalAction?.icon}
        textOutlinedButton={modalAction?.textOutlinedButton || ''}
        textContainedButton={modalAction?.textContainedButton || ''}
        title={modalAction?.title || ''}
        subTitle={modalAction?.subTitle || ''}
        handleOutlinedButton={modalAction?.handleOutlinedButton}
        handleContainedButton={modalAction?.handleContainedButton}
      />
    </>
  )
}

export default AnexoButton